import { useEffect } from "react";

// Disabled RUM tracking for privacy compliance
export function useDatadogRum() {
  // No-op function - RUM tracking disabled for healthcare privacy compliance
  useEffect(() => {
    // RUM tracking has been disabled to ensure maximum patient privacy
    // and eliminate iOS Safari privacy warnings
    console.log("Analytics tracking disabled for privacy compliance");
  }, []);
}

export default useDatadogRum;
